import { TicketViewSchema } from '@fsf/types';
import { _ } from '@ngx-translate/core';
import { z } from 'zod';
import {
  DEFAULT_LANGUAGE_CODE,
  LanguageCodeSchema,
} from '../../util/language-codes';

export type Ticket = z.infer<typeof TicketViewSchema>;

const ticketDetailSchema = z.object({
  language: LanguageCodeSchema,
  title: z.string().min(1, { message: 'validation.required' }).max(255),
});

export const StoreTicketSchema = z.object({
  product_id: z.number().int().min(1, { message: 'validation.required' }),
  min_amount: z.number().int().min(0).nullable().optional(),
  max_amount: z.number().int().min(0).nullable().optional(),
  is_included: z.boolean().optional(),
  details: z
    .array(ticketDetailSchema)
    .min(1)
    .superRefine((rows, ctx) => {
      const langs = rows.map((r) => r.language);
      if (new Set(langs).size !== langs.length) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: _('validation.duplicateLanguage'),
        });
      }
      if (!langs.includes(DEFAULT_LANGUAGE_CODE)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: _('validation.defaultLanguageRequired'),
        });
      }
    }),
});

export type StoreTicketPayload = z.infer<typeof StoreTicketSchema>;
export const UpdateTicketSchema = StoreTicketSchema.partial();
export type UpdateTicketPayload = z.infer<typeof UpdateTicketSchema>;

export const ticketTranslations = _([
  'catalog.tickets.title',
  'catalog.tickets.add',
  'catalog.tickets.edit',
  'catalog.tickets.empty',
  'catalog.tickets.included',
  'catalog.tickets.notIncluded',
  'catalog.tickets.deleteConfirmHeader',
  'catalog.tickets.deleteConfirmMessage',
  'catalog.tickets.created',
  'catalog.tickets.updated',
  'catalog.tickets.deleted',
  'catalog.tickets.createError',
  'catalog.tickets.updateError',
  'catalog.tickets.deleteError',
  'catalog.tickets.dirtyHint',
  'catalog.tickets.fields.titleDe',
  'catalog.tickets.fields.titleEn',
  'catalog.tickets.fields.minAmount',
  'catalog.tickets.fields.maxAmount',
  'catalog.tickets.fields.isIncluded',
]);
